import { PlannerValidation } from '@inter-ikea-storageone/range';
import ProhibitAdjustableComponent from '../components/ProhibitAdjustableComponent';
import { MOUNTING_RAIL_ADJUSTABLE_CONNECTORS } from '@inter-ikea-storagetwo/boaxel/dist/constants/connectorKeys';
export class AdjustableSectionValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'AdjustableSectionValidation');
        this.coreApi = coreApi;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        if (!this.isEnabled)
            return this.validationOK();
        const host = snapActionCandidate.host;
        if (host.hasComponent(ProhibitAdjustableComponent.id)) {
            if (MOUNTING_RAIL_ADJUSTABLE_CONNECTORS.includes(snapActionCandidate.hostConnector.key)) {
                return this.validationFail('Adjustable size not supported');
            }
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=AdjustableSectionValidation.js.map